<ng-container *transloco="let t">
<section class="next-race-section upper-section-background">
  <div class="container mt-4">
    <section>
      <div class="row row-cols-1">
        <div class="col mb-4">
          <div class="d-flex fw-500 fs-20 mb-3">
            <div class="red-vertical-line"></div>
            <p>{{ t('event.item.card.preview.list.view')}}</p>
          </div>
          <app-event-grid-item (click)="goToEventDetailsPage()" [eventItem]="event"
                                              [languages]="languages" [isPreviewComponent]="isPreviewComponent"
                                              [layout]="CalendarViewType.LIST"/>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
        <div class="col mb-4">
          <div class="d-flex fw-500 fs-20 mb-3">
            <div class="red-vertical-line"></div>
            <p>{{ t('event.item.card.preview.grid.view')}}</p>
          </div>
          <app-event-grid-item (click)="goToEventDetailsPage()"
                               [eventItem]="event"
                               [languages]="languages"
                               [isPreviewComponent]="isPreviewComponent"
                               [layout]="CalendarViewType.GRID"/>
        </div>
      </div>
    </section>
  </div>
</section>
</ng-container>
